import { render, staticRenderFns } from "./rules_en.vue?vue&type=template&id=3a0c7f4b&"
import script from "./rules_en.vue?vue&type=script&lang=js&"
export * from "./rules_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports